import {api} from "./index";
import {FewAvailableLessonsStatisticResponse, PaymentStatisticResponse} from "../../shared/types/report";
import {PageRequest, PageResponse} from "../../shared/types/page";

export const getPaymentStatisticsFetch = async (request: PageRequest): Promise<PageResponse<PaymentStatisticResponse>> => {
    if (request.filters?.length === 0) return {
        pageNumber: 0,
        pageSize: 0,
        totalElements: 0,
        totalPages: 1,
        content: []
    };

    const params = new URLSearchParams();

    request.filters?.forEach(filter => {
        params.append(filter.fieldName, filter.fieldValue);
    })

    const paymentStatistics = (await api.get<PaymentStatisticResponse[]>(
        `/statistics/payments?${params.toString()}`
    )).data;

    return {
        pageNumber: 0,
        pageSize: paymentStatistics.length,
        totalElements: paymentStatistics.length,
        totalPages: 1,
        content: paymentStatistics
    }
};

export const getFewAvailableLessonsStatisticsFetch = async (request: PageRequest): Promise<PageResponse<FewAvailableLessonsStatisticResponse>> => {
    const fewAvailableLessonsStatistics = (await api.get<FewAvailableLessonsStatisticResponse[]>(
        `/statistics/few-available-lessons`
    )).data;

    return {
        pageNumber: 0,
        pageSize: fewAvailableLessonsStatistics.length,
        totalElements: fewAvailableLessonsStatistics.length,
        totalPages: 1,
        content: fewAvailableLessonsStatistics
    }
};